// src/pages/Wallet/chainLogos.js
// Direct imports of local images through webpack
import ethLogo from '../../assets/ethereum.png';
import bitrockLogo from '../../assets/bitrock.png';
import baseLogo from '../../assets/base.svg';
import bscLogo from '../../assets/bnb.png';
import arbLogo from '../../assets/arbitrum.svg';
import infLogo from '../../assets/infinaeon.svg';
import avaxLogo from '../../assets/avalanche.svg';
import omaxLogo from '../../assets/omax.png';
import polLogo from '../../assets/polygon.svg';
import celoLogo from '../../assets/celo.png';
import optimismLogo from '../../assets/optimism.svg';
import cronosLogo from '../../assets/cronos.svg';
import taraxaLogo from '../../assets/taraxa.png';


// Simple object mapping chain keys to their imported image
const chainLogos = {
  ethereum: ethLogo,
  bitrock: bitrockLogo,
  base: baseLogo,
  bsc: bscLogo,
  arbitrum: arbLogo,
  infinaeon: infLogo,
  polygon: polLogo,
  avalanche: avaxLogo,
  celo: celoLogo,
  optimism: optimismLogo,
  cronos: cronosLogo,
  omax: omaxLogo,
  taraxa: taraxaLogo,
  // Add more chains here with their imported logos
};

/**
 * Get logo for a specific chain with fallback to Ethereum
 */
export const getChainLogo = (chainKey) => {
  // If we have a direct import for this chain, return it
  if (chainLogos[chainKey]) {
    return chainLogos[chainKey];
  }
  
  // Fallback to Ethereum logo
  console.warn(`No logo found for chain: ${chainKey}, using default`);
  return ethLogo;
};

// Export the direct mapping for backward compatibility
export default chainLogos;